import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { catalogBibShape, ugcSummaryShape } from '@bibliocommons/bc-prop-types';
import { ChevronLink } from '@bibliocommons/base-links';
import { ExpandableText } from '@bibliocommons/expandable';

import UgcList from 'app/components/bibs/shared/ugc/UgcList';
import { SummaryEditorContainer } from 'app/components/bibs/shared/ugc/SummaryEditor';
import SummaryDisplayContainer from 'app/components/bibs/shared/ugc/SummaryDisplay';
import { ugcSummaryShape as bibUgcSummaryShape } from 'app/shapes/bibPage';

import './Summaries.scss';

export default class Summaries extends React.PureComponent {
  handleSuccess = () => {
    const metadataId = this.props.catalogBib.get('metadataId');
    this.props.bibsActions.fetchUGC(metadataId);
  };

  renderSummary = summary => {
    return (
      <SummaryDisplayContainer
        summary={summary}
        catalogBib={this.props.catalogBib}
        handleDeleteSuccess={this.handleSuccess}
      >
        <ExpandableText
          text={summary.get('summary')}
          truncateCount={240}
          expandLinkHref={`#read-more-ugc-display-${summary.get('id')}`}
          textKey="summary"
        />
      </SummaryDisplayContainer>
    );
  };

  renderEditor = () => {
    const { currentUserSummaries, catalogBib } = this.props;
    return (
      !currentUserSummaries.get(catalogBib.get('metadataId')) && (
        <SummaryEditorContainer catalogBib={catalogBib} handleSuccess={this.handleSuccess} />
      )
    );
  };

  render() {
    const { summary, summaries, summariesTransactions, catalogBib } = this.props;
    const totalSummariesCount = summary?.getIn(['summaries', 'total']) ?? 0;
    const displayedSummariesCount = summaries.size;
    return (
      <div className="cp-summaries" data-key="summaries">
        <UgcList
          items={summaries}
          catalogBib={catalogBib}
          transactions={summariesTransactions}
          renderItem={this.renderSummary}
          renderEditor={this.renderEditor}
          contentType="summaries"
        />
        {totalSummariesCount > displayedSummariesCount && (
          <ChevronLink
            className="all-summaries"
            href={`/v2/record/${catalogBib.get('metadataId')}/summaries`}
            dataKey="all-summaries"
          >
            <FormattedMessage id="view_all_summaries" values={{ count: totalSummariesCount }} />
          </ChevronLink>
        )}
      </div>
    );
  }
}

Summaries.propTypes = {
  summaries: ImmutablePropTypes.list.isRequired,
  currentUserSummaries: ImmutablePropTypes.mapOf(ugcSummaryShape),
  summary: bibUgcSummaryShape,
  summariesTransactions: ImmutablePropTypes.map.isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  catalogBib: catalogBibShape.isRequired
};
